<template>
  <article-detail-component v-if="article">

    <div slot="anchors" class="anchors">
      <div v-for="(value, key) in anchors"><a :class="{active: $route.hash == ('#'+key) || (key == 'Tables' && !$route.hash)}" :href="'#'+key">{{ value }}</a></div>
    </div>

    <div slot="keywords" class="keywords">
      <div class="title">
        Keywords:
      </div>
      <div class="">
        <div class="link" v-for="keyword in article.keywords">{{keyword}}</div>
      </div>
    </div>

    <div slot="title">
      <div class="title">{{ article.title }}</div>
      <issue-authors v-bind:authors="article.authors"></issue-authors>
    </div>

    <sidebar-article-section slot="bar" :article="article"></sidebar-article-section>

    <div slot="full_text">
      <title-block title="Tables" id="Tables" color-theme="primary-color">
      </title-block>

      <title-block title="Figures" id="Figures" color-theme="primary-color">
        <div class="fullText" v-for="figure in article.files.figures">
          <section>
            <h1>{{figure.label}}</h1>
            <img :src="figure.url"/>
            <p v-html="figure.caption"></p>
          </section>
        </div>
      </title-block>

      <title-block title="Videos" id="Videos" color-theme="primary-color">
      </title-block>
    </div>

  </article-detail-component>
</template>

<script>
  import TitleBlock from '@/components/shared/TitleBlockComponent'
  import IssueAuthors from '@/components/shared/IssueAuthorsComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  import ArticleDetailComponent from '@/components/publications/article-detail/ArticleDetailComponent'
  import ContentHeader from '@/components/shared/article-items/ContentHeaderComponent'
  import ContentItem from '@/components/shared/article-items/ContentItemComponent'
  import SidebarArticleSection from '@/components/main-layout/sidebar/SidebarArticleSectionComponent'

  export default {
    name: 'article-data',
    data () {
      return {
        article: false,
        anchors: {}
      }
    },
    mixins: [ UtilityMixin ],
    components: {
      TitleBlock,
      IssueAuthors,
      ArticleDetailComponent,
      ContentHeader,
      ContentItem,
      SidebarArticleSection
    },
    methods: {
      fillAnchors () {
        // Fill anchors menu
        this.anchors['Tables'] = 'Tables'
        this.anchors['Figures'] = 'Figures'
        this.anchors['Videos'] = 'Videos'
      }
    },
    watch: {
      article: function () {
        this.fillAnchors()
      }
    },
    created () {
      if (this.$parent.article) {
        this.article = Object.assign({}, this.$parent.article)
        this.fillAnchors()
      }
    }
  }
</script>


<style lang="scss" scoped>
  [id]:before {
    display: block;
    content: "";
    height: 55px;
    margin: -55px 0 0;
  }
  .anchors {
    padding: 10px;
    background-color: $devider;
    a {
      text-decoration: underline;
      color: $accent-color-2;
      padding: 5px;
      display: block;
    }
    a.active {
      color: $black;
      font-weight: 700;
      text-decoration: none;
    }
  }

  .keywords {
    margin-top: 10px;
    .title {
      font-family: 'Merriweather';
      font-style: italic;
      color: $primary-color;
      font-size: 14px;
      margin-bottom: 15px;
    }
    .link {
      height: 48px;
      line-height: 48px;
      text-align: center;
      font-family: 'Merriweather';
      font-style: italic;
      font-size: 16px;
      color: $primary-color;
      background-color: #F2E8E8;
      margin-bottom: 12px;
      display: inline-block;
      width: 135px;
      margin-right: 5px;
    }
  }

  .title {
    color: $primary-color;
    font-size: 32px;
  }
  h1 {
    color: $primary-color;
    font-weight: 300;
    font-size: 24px;
    text-transform: uppercase;
  }
  h2 {
    color: $primary-color;
    font-weight: 300;
    font-size: 18px;
    text-transform: uppercase;
  }
  .article-quick-links {
    margin-bottom: 40px;
  }
  section {
    text-align: justify;
    img {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// ArticleDataPage.vue?e08e2d04